import { NavLink } from "react-router-dom";
import Icon from "@ant-design/icons";

import CompanyName from "@/shared/assets/icons/logo/company-name.svg?react";
import LogoIcon from "@/shared/assets/icons/logo/logo.svg?react";
import { MainRoutes } from "@/shared/routing";

export const Logo = ({ isOpenMenu = false }: { isOpenMenu?: boolean }) => (
	<NavLink to={MainRoutes.Root} className="flex items-center justify-start m-0">
		<Icon component={() => <LogoIcon className="h-[23px] w-auto text-ant-color-primary" />} />

		<Icon
			component={() => <CompanyName className="ml-8 h-[23px] w-auto text-ant-color-primary" />}
			alt="Company Name"
			style={{
				transition: "all 0.3s",
				overflow: "hidden",
				maxWidth: isOpenMenu ? "100%" : 0,
			}}
		/>
	</NavLink>
);
